import { showInfo, showError } from '@/utils/alertUtils';

class NetworkService {
    constructor(i18n = null) {
        this.isOnline = navigator.onLine;
        this.listeners = [];
        this.lastNotificationTime = 0;
        this.notificationCooldown = 2000; // bekleme süresi
        this.i18n = i18n;
        this.init();
    }

    init() {
        // Online/offline event listeners
        window.addEventListener('online', () => this.handleOnline());
        window.addEventListener('offline', () => this.handleOffline());

        // İlk yüklemede bağlantı durumunu kontrol et
        this.checkInitialStatus();
    }

    handleOnline() {
        // Eğer zaten online ise, tekrar bildirim gösterme
        if (this.isOnline) {
            return;
        }

        this.isOnline = true;
        this.notifyListeners(true);

        // Cooldown kontrolü
        const now = Date.now();
        if (now - this.lastNotificationTime > this.notificationCooldown) {
            this.lastNotificationTime = now;
            const message = this.i18n ? this.i18n.t('general.internet_connected') : 'İnternet bağlantısı kuruldu';
            showInfo(message, 3000);
        }
    }

    handleOffline() {
        // Eğer zaten offline ise, tekrar bildirim gösterme
        if (!this.isOnline) {
            return;
        }

        this.isOnline = false;
        this.notifyListeners(false);

        // Cooldown kontrolü
        const now = Date.now();
        if (now - this.lastNotificationTime > this.notificationCooldown) {
            this.lastNotificationTime = now;
            const message = this.i18n ? this.i18n.t('general.internet_connection_gone') : 'İnternet bağlantınız kesildi. Lütfen bağlantınızı kontrol edin.';
            showError(message, 0);
        }
    }

    checkInitialStatus() {
        // Sayfa yüklendiğinde bağlantı durumunu kontrol et
        // İlk yüklemede bildirim gösterme, sadece durumu ayarla
        if (!this.isOnline) {
            this.notifyListeners(false);
        }
    }

    notifyListeners(isOnline) {
        this.listeners.forEach(callback => {
            try {
                callback(isOnline);
            } catch (error) {
                console.error('Network listener error:', error);
            }
        });
    }

}

const networkService = new NetworkService();

export default networkService;
